jQuery(document).ready(function ($) {

    $('body').on('click', '.accordion-item .headline', function (e) {
        e.preventDefault();
        var expanded = $(this).attr('aria-expanded') == 'false' ? 'true' : 'false'
        $(this).closest('.accordion-item').find('.description').stop().slideToggle(400, function () {
            // refresh simpleselect in case it is used
            try {
                $(this).find('select').each(function () {
                    $(this).simpleselect("updatePresentationDependentVariables");
                });
            } catch (errowprThrown) { return; }
        });
        $(this).parent().stop().toggleClass('active');
        $(this).attr('aria-expanded', expanded);
    });

    $(".accordion-item .description.opened").css('display', 'block');

    // open accordion on keypress
    $('body').on('keypress', '.accordion-item > .headline', function (e) {
        e.preventDefault();
        if (e.target !== this) return;
        if (e.code == "Enter" || e.keyCode == 13 || e.code == "Space" || e.keyCode == 32) {
            $(this).trigger('click');
        }
    });

});


// WEBPACK FOOTER //
// ./src/blocks/accordion/js/script.js